export default [
	{
		name: 'Name',
		field: 'name',
		width: 'large'
	},
	{
		name: 'Phone',
		field: 'phone',
		width: 'medium'
	},
	{
		name: 'Address',
		field: 'address1',
		width: 'large'
	},
	{
		name: 'City',
		field: 'city',
		width: 'medium'
	},
	{
		name: 'State',
		field: 'state',
		width: 'small'
	},
	{
		name: 'Zip',
		field: 'postal_code',
		width: 'small',
	},
	{
		name: 'Active',
		field: 'is_active',
		isToggle: true,
		width: 'small'
	}
]



/** WEBPACK FOOTER **
 ** ./src/tables/locations.js
 **/